import * as React from "react";
import classnames from "classnames";
import { Button } from "@grandvisionhq/common";
import { Heading, Hr, Text } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import { Containers } from "@grandvisionhq/stores-v2";
import { AppointmentConfirmationInstructionsContainer } from "../../../../AppointmentConfirmationInstructions/v3/components/AppointmentConfirmationInstructions/AppointmentConfirmationInstructionsContainer.js";
import AppointmentOverviewContainer from "../../../../AppointmentOverview/v3/components/AppointmentOverview/AppointmentOverviewContainer.js";
import { AppointmentProduct } from "../../../../AppointmentProducts/v3/components/AppointmentProducts/AppointmentProduct.js";
import AppointmentSurveyContainer from "../../../../AppointmentSurvey/v3/components/AppointmentSurvey/AppointmentSurveyContainer.js";
import ICSButton from "../../../../ICSButton/v3/components/ICSButton/ICSButton.js";
import StoreOverviewContainer from "../../../../StoreOverview/v3/components/StoreOverview/StoreOverviewContainer.js";
import UserInfoOverviewContainer from "../../../../UserInfoOverview/v3/components/UserInfoOverview/UserInfoOverviewContainer.js";
/* empty css                             */
const StoreOffers = Containers.StoreOffers;
const AppointmentConfirmation = ({
  className,
  labels,
  store,
  offers,
  type,
  timeSlot,
  appointment,
  tryInStoreProducts,
  googleMapsApiKey,
  storesUrl,
  directionsUrl,
  appointmentConfirmationContent,
  offerFallbackImageUrl,
  isVirtualAppointmentType,
  onICSButtonClick
}) => /* @__PURE__ */ React.createElement("main", { className: classnames("appointment-confirmation", className) }, /* @__PURE__ */ React.createElement("div", { className: "appointment-confirmation__headings" }, /* @__PURE__ */ React.createElement(Heading, { className: "appointment-confirmation__heading", component: "h2", variant: "small" }, labels.heading), /* @__PURE__ */ React.createElement(Hr, { className: "appointment-confirmation__horizontal-rule" }), labels.subHeading && /* @__PURE__ */ React.createElement("p", { className: "appointment-confirmation__sub-heading" }, labels.subHeading)), /* @__PURE__ */ React.createElement(
  Alert,
  {
    variant: "success",
    title: labels.notification,
    className: "alert-m-default appointment-confirmation__alert"
  }
), tryInStoreProducts ? /* @__PURE__ */ React.createElement("section", { className: "appointment-confirmation__section appointment-confirmation__try-in-store" }, /* @__PURE__ */ React.createElement(Heading, { className: "appointment-confirmation__section-heading", variant: "smallest" }, labels.tryInStoreProducts), tryInStoreProducts.map((product, i) => /* @__PURE__ */ React.createElement(AppointmentProduct, { key: i, product })), /* @__PURE__ */ React.createElement(Text, { className: "appointment-confirmation__try-in-store-disclaimer", color: "text-secondary" }, labels.tryInStoreProductsDisclaimer)) : null, /* @__PURE__ */ React.createElement("section", { className: "appointment-confirmation__section appointment-confirmation__appointment" }, /* @__PURE__ */ React.createElement(Heading, { className: "appointment-confirmation__section-heading", variant: "smallest" }, labels.appointment), /* @__PURE__ */ React.createElement(
  AppointmentOverviewContainer,
  {
    className: "appointment-confirmation__section-content appointment-confirmation__appointment_overview",
    appointment: { ...appointment, invitee: void 0, child: void 0 }
  }
), !appointment.isReservation && /* @__PURE__ */ React.createElement(
  ICSButton,
  {
    className: "appointment-confirmation__button",
    caption: labels.addToCalendar,
    appointmentType: type,
    timeSlot,
    store,
    variant: "outline",
    onClick: onICSButtonClick
  }
)), /* @__PURE__ */ React.createElement(AppointmentSurveyContainer, null), !isVirtualAppointmentType && /* @__PURE__ */ React.createElement("section", { className: "appointment-confirmation__section appointment-confirmation__where" }, /* @__PURE__ */ React.createElement(Heading, { className: "appointment-confirmation__section-heading", variant: "smallest" }, labels.where), googleMapsApiKey && storesUrl && /* @__PURE__ */ React.createElement(
  StoreOverviewContainer,
  {
    className: "appointment-confirmation__section-content",
    store,
    googleMapsApiKey,
    storesUrl
  }
), directionsUrl && /* @__PURE__ */ React.createElement(
  Button,
  {
    className: "appointment-confirmation__button",
    variant: "outline",
    hrefTarget: "_blank",
    href: directionsUrl,
    caption: labels.getDirections
  }
)), !appointment.isReservation && appointmentConfirmationContent && /* @__PURE__ */ React.createElement(
  AppointmentConfirmationInstructionsContainer,
  {
    confirmationContent: appointmentConfirmationContent
  }
), /* @__PURE__ */ React.createElement("section", { className: "appointment-confirmation__section appointment-confirmation__who" }, /* @__PURE__ */ React.createElement(Heading, { className: "appointment-confirmation__section-heading", variant: "smallest" }, labels.who), /* @__PURE__ */ React.createElement(
  UserInfoOverviewContainer,
  {
    className: "appointment-confirmation__section-content",
    user: {
      firstName: appointment.invitee?.firstName,
      lastName: appointment.invitee?.lastName,
      email: appointment.invitee?.email,
      phone: appointment.invitee?.phone,
      child: appointment.child
    }
  }
)), !appointment.isReservation && /* @__PURE__ */ React.createElement("section", { className: "appointment-confirmation__section appointment-confirmation__cant-make-it" }, /* @__PURE__ */ React.createElement(Heading, { className: "appointment-confirmation__section-heading", variant: "smallest" }, labels.cantMakeIt), /* @__PURE__ */ React.createElement("p", { className: "appointment-confirmation__section-content appointment-confirmation__cancel-or-reschedule" }, labels.cancelOrReschedule)), !appointment.isReservation && offers && offers.length > 0 && /* @__PURE__ */ React.createElement(
  StoreOffers,
  {
    className: "appointment-confirmation__store-offers",
    fallbackImage: offerFallbackImageUrl,
    offers,
    linkTarget: "_blank"
  }
), /* @__PURE__ */ React.createElement(
  Button,
  {
    className: "appointment-confirmation__button",
    variant: "outline",
    hrefTarget: "_blank",
    href: "/",
    caption: labels.exploreProducts
  }
));
export {
  AppointmentConfirmation as default
};
//# sourceMappingURL=AppointmentConfirmation.js.map
